import { Injectable, OnDestroy } from '@angular/core';
import { ApModalResult, ApModalService } from 'webcommon/core-ui';
import { ApBaseClass, IColumnPk } from 'webcommon/shared';
import { FcItemModalContext, FcItemModalMode } from '../models/index';
import { ApFindControlService } from './ap-findcontrol.service';
import { FcItemConfig } from './fc-item-config';

@Injectable({
  providedIn: 'root',
})
export class FcItemModalService extends ApBaseClass implements OnDestroy {
  constructor(
    private apModalService: ApModalService,
    private fcItemConfig: FcItemConfig,
    private apFindControlService: ApFindControlService,
  ) {
    super();
  }

  openModal(
    fcModalItemContext: FcItemModalContext,
  ): Promise<ApModalResult<IColumnPk>> {
    const initialState = {
      fcModalItemContext
    };

    const findControlModalType = this.fcItemConfig.getItemModalTypeOrDefault(fcModalItemContext);

    const p = this.apModalService.showComponentModal(findControlModalType.component, {
      panelClass: findControlModalType.modalSize,
      disableClose: true,
      initialState,
    });

    if (fcModalItemContext.mode === FcItemModalMode.Modify) {
      this.apFindControlService.updateMfuMruList(fcModalItemContext.findControlId, [fcModalItemContext.selectedFindItemPk]).pipe(
        this.takeUntilDestroy(),
      ).subscribe();
    }

    return p;
  }
}
